import React, {Component} from 'react';
import MetaTags from 'react-meta-tags';

// Components
import BrowserThumb from '../../components/BrowserThumb/BrowserThumb';
import RandomReview from '../../components/RandomReview/RandomReview';
import Anime from '../../components/Anime/Anime';

// Containers
import AppTitle from '../../containers/AppTitle/AppTitle';
import StandardFeatures from '../../containers/StandardFeatures/StandardFeatures';
import Themes from '../../containers/Themes/Themes';
import Hero from '../../containers/Hero/Hero';
import HeroLayer from '../../containers/Hero/HeroLayer';

class PageHome extends Component {
    render () {

        // AppTitle
        const title = {
			title      : 'We just make creative WordPress themes',
			subTitle   : 'Our team has been specializing in easy to use themes with outstanding customer support.',
			buttonTitle: 'View WordPress Themes'
        };

        return (
            <div className="app-section mb-sm">
                <MetaTags>
                    <title>We just make creative WordPress themes</title>
                    <meta name="description" content="Our team has been specializing in easy to use themes with outstanding customer support." />
                </MetaTags>

                <Hero height="" classes="hero-home">

                	<div className="container">
	                    <AppTitle data={title} classes="mb mb-sm" />
	                </div>

	                <HeroLayer 
	                	index="2" 
	                	classes="latest-theme theme-layer anim anim--fade-up anim--duration-4 anim--delay-5"
                    	styleOuter={{
                    		zIndex:2,
                    		position: "relative"
                    	}}
                    	styleInner={{
                    		position:"relative",
                    		top: "auto",
                    		bottom: "-40px",
                    		left:0,
                    		right:0,
                    		margin:"auto",
                    		maxWidth: "1200px"
                    	}}
	                >
	                    <BrowserThumb 
	                        title="Hamon"
	                        link="/theme/hamon"
	                        src="images/_latest-theme.jpg"
	                        srcLow="images/_latest-theme-small.jpg" 
	                        imageAlt="Recent Theme"
	                        bgColor="#000000"
	                        width="1200"
	                        height="720" 
	                        classes="shadow"
	                    />
                    </HeroLayer>

                    <HeroLayer
                    	classes="lines-bg anim anim--fade anim--duration-8 anim--delay-1"
                    	styleOuter={{
                    		zIndex:1
                    	}}
                    	styleInner={{
                    		top: 0,
                    		bottom: 0,
                    		left:0,
                    		right:0,
                    		opacity:0.6,
                    		backgroundSize: "cover",
                    		backgroundImage: "url(https://rascalsthemes.com/images/dark-texture.jpg)",
                    	}}
                    />
                </Hero>

                <div className="container">

					<Anime type="fade" delay="2" duration="5">
	                    <StandardFeatures title="Theme Standard Features" classes="mb2 mb-sm" />
	                    
	                    <RandomReview classes="mb mb-sm" />

	                    <Themes title="Latest Themes" limit="3" grid="col-12 col-md-4 mb2-md" classes="mb mb-sm" />
	                </Anime>

                </div>
            </div>
        );
    }
}

export default PageHome;


// WEBPACK FOOTER //
// ./src/pages/PageHome/PageHome.js